import { Component, input, output, ChangeDetectionStrategy, effect } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-date-picker',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
  ],
  providers: [provideNativeDateAdapter()],
  host: {
    '[style.--brand-color]': 'brandColor()',
  },
  templateUrl: './date-picker.html',
  styleUrl: './date-picker.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatePicker {
  value = input<string>('');
  brandColor = input<string>('#32d800');
  minDate = input<string | null>(null);
  valueChange = output<string>();

  dateControl = new FormControl<Date | null>(null);

  get minDateAsDate(): Date | null {
    const iso = this.minDate();
    if (!iso) return null;
    const dt = DateTime.fromISO(iso);
    return dt.isValid ? dt.toJSDate() : null;
  }

  constructor() {
    effect(() => {
      const iso = this.value();
      if (iso) {
        const dt = DateTime.fromISO(iso);
        if (dt.isValid) {
          this.dateControl.setValue(dt.toJSDate(), { emitEvent: false });
        }
      }
    });

    // The calendar panel is portalled to <body> so it can't inherit --brand-color
    // from the component host. Setting it on :root makes it available globally.
    effect(() => {
      document.documentElement.style.setProperty('--brand-color', this.brandColor());
    });

    this.dateControl.valueChanges.subscribe(date => {
      if (date) {
        this.valueChange.emit(DateTime.fromJSDate(date).toISODate()!);
      }
    });
  }
}
